import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Captcha from "@src/common/Captcha";
import { CaptchaData } from "@src/common/Captcha";
import { LoginHandler,googleWithLogin,createOtp } from "@src/store/slices/user";
import VerifyOtp from "./VerifyOtp";
import secureStorage from "@src/config/encrypt";
import GoogleLoginComponent from './GoogleLogin';
import { useSearchParams } from 'react-router-dom';
// import * as HELPER from "@src/config/helper";
// import { ROLE_FEATURES } from '@src/config/constant';
import { useDispatch } from 'react-redux';
// import FullPageLoader from '@common/FullPageLoader';
import { toast } from 'react-toastify';
import { Link } from "react-router-dom";
import { REGEX_EMAIL, REGEX_MOBILE, STATUS_CODES, LOGIN_TYPE } from '@src/config/constant';

// interface EmailUserProps {
//     setShowMobileLinks: any;
//     setShowEmailLinks: any;
//     showCaptcha: any;
// }

interface LoginRequest {
    email: string;
    password?: string; 
    captcha?: string; 
    hash ?: string;
    source: string;
}

interface RegisterRequest {
    name : string,
    email: string;
    mobile : string,
    captcha?: string; 
    hash ?: string;
    source: string;
}


function EmailUser(props: any) {


    const validEmailRegex = RegExp(REGEX_EMAIL); // eslint-disable-line

    const [otp, setOtp] = useState("");
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [inputField, setInputField] = useState({
        name : "",
        email: "",
        password: "",
        captcha: "",
        hash: "",
        mobile: "",
        source:"web",
        formType:""
    });
    const [errField, setErrField] = useState<any>({
        name : "",
        email: "",
        password: "",
        isCaptchaInvalid: false,
        captchaError: "",
        captcha: "",
        otp: "",
        mobile: "",
    });
    const [showVerify, setShowVerify] = useState<boolean>(false);
    const [userId, setUserId] = useState<string>('');
    const navigate = useNavigate();
    const [reloadCaptcha, setReloadCaptcha] = useState(1);
    // eslint-disable-next-line
    const [googleLogin, setGoogleLogin] = useState(false);
    const [searchParams] = useSearchParams();
    const dispatch = useDispatch();


    const validForm = () => {
        let formIsValid = true;
        setErrField({
            name : "",
            email: "",
            password: "",
            isCaptchaInvalid: false,
            captchaError: "",
            captcha: "",
            otp: "",
            mobile: "",
        });

        if (inputField.email === "") {

            formIsValid = false;
            setErrField((prevState: any) => ({
                ...prevState,
                email: "Email is required",
            }));
        } else if (!validEmailRegex.test(inputField.email)) {

            formIsValid = false;
            setErrField((prevState: any) => ({
                ...prevState,
                email: "Please enter valid email",
            }));
        }
        if(inputField.formType && inputField.formType === "REGISTER"){
            if (inputField.name === "" || inputField.name.trim() === "") {
                formIsValid = false;
                setErrField((prevState: any) => ({
                    ...prevState,
                    name: "Name is required",
                }));
            } else if (!/^[A-Za-z\s]+$/.test(inputField.name)) {
                formIsValid = false;
                setErrField((prevState: any) => ({
                    ...prevState,
                    name: "Name should contain only alphabets",
                }));
            }

            if (inputField.mobile === "" || inputField.mobile.trim() === "") {
                formIsValid = false;
                setErrField((prevState: any) => ({
                    ...prevState,
                    mobile: "Mobile No. is required",
                }));
            }else if (!REGEX_MOBILE.test(inputField.mobile)) {
                formIsValid = false;
                setErrField((prevState: any) => ({
                    ...prevState,
                    mobile: "Mobile No. must be 10 digits and start with 9",
                }));
            }
            
        }else{
            if (inputField.password === "") {
    
                formIsValid = false;
                setErrField((prevState: any) => ({
                    ...prevState,
                    password: "Password is required",
                }));
            }
        }
        // if (!inputField['captcha'].trim()) {

        //     formIsValid = false;
        //     setErrField((prevState: any) => ({
        //         ...prevState,
        //         captcha: "Captcha is required",
        //     }));
        //     setReloadCaptcha((prev) => prev + 1)
        // }

        return formIsValid;
    };

    const inputHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        if (name === "otp") {
            setOtp(value);
        }
        else {
            setInputField({ ...inputField, [name]: value });
        }
        errField[name] = '';
        setErrField({ ...errField });
    };

    useEffect(() => {
        const loggedInUser = secureStorage.getItem("authAgentUserInfo");
        if (loggedInUser && loggedInUser.user_data.login_type === LOGIN_TYPE[1] ) {
            //  `sales_user_id` - this user is an Agency mapped under an SO = go to dashboard
            if (loggedInUser?.user_data?.sales_user_id) {
                navigate('/dashboard');
                return;
            }    
            navigate('/mapping-agency-list');
        }
        else if(loggedInUser && loggedInUser.user_data.login_type === LOGIN_TYPE[0]){
             navigate('/dashboard');
        }
        //     else{
        //       navigate('/login');
        // }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (props.isRegister) {
            setInputField((prevState) => ({
                ...prevState,
                formType: "REGISTER"
            }));
        }
    }, [props.isRegister]);



    const submitButton = async () => {
        setLoading(true);
        if (validForm()) {
            try{
                if(inputField.formType && inputField.formType === "REGISTER"){
                    const registerRequestData: RegisterRequest = {
                        name : inputField.name,
                        email: inputField.email,
                        mobile : inputField.mobile,
                        captcha: inputField.captcha || "", 
                        hash : inputField.hash,
                        source:inputField.source
                    };
                    createOtp(registerRequestData).then((res) => {
                        setLoading(false)
                        if (res && res.data) {
                            //DELETE CAPTCHA HASH FROM CACHE 
                            setUserId(res && res.data && res.data.user_id);
                            setShowVerify(true);
                            props.setShowEmailLinks(true);
                            props.setShowMobileLinks(false);
                            props.setIsOtpVerifyScreen(true);
        
                        }
                        setReloadCaptcha((prev) => prev + 1)
                        setInputField({ ...inputField, email: inputField.email, captcha: '' })
        
                    });
                }else{
                    const loginRequestData: LoginRequest = {
                        email: inputField.email,
                        password: inputField.password || "" , 
                        captcha: inputField.captcha || "", 
                        hash : inputField.hash,
                        source:inputField.source
                    };
                    const response: any = await LoginHandler(loginRequestData, dispatch);
                    setLoading(false);
                    if (response.status === STATUS_CODES['success']) {
                        if (response.data.user_data.login_type === LOGIN_TYPE[1]) {
                            navigate('/mapping-agency-list');
                        } else if(response.data.user_data.login_type === LOGIN_TYPE[0]){
                            navigate('/dashboard');
                        } else {
                        navigate('/login');
                        }                       
                    }else{
                        navigate('/login')
                        setReloadCaptcha((prev) => prev + 1)
                    }
                }
            }catch (error) {
                // Handle any errors here
                setReloadCaptcha((prev) => prev + 1)
                setLoading(false);
            }
        } else {
            setReloadCaptcha((prev) => prev + 1)
            setLoading(false);
        }
    };

    const captchaFiledHandler = (captchaValue: string, captchaImage: CaptchaData) => {
        if (captchaImage.data) {
            setInputField({ ...inputField, captcha: captchaValue, hash: captchaImage.data.value });
        }
    };
    


    useEffect(() => {
        const userDataParam: any = searchParams.get('userdata');
        if (userDataParam) {
            try {
                setLoading(true);
                const parsedData = JSON.parse(decodeURIComponent(userDataParam));

                if ((!parsedData.domain && parsedData.email) || parsedData.domain !== "Invalid") {
                    setLoading(true);
                    setInputField({ ...inputField, email: parsedData.email, password: "", captcha: '' });

                    googleWithLogin({"email":parsedData.email, logintype:"googleLogin", "source": "web"}, dispatch)
                        .then(async (result: any) => {
                            if (result.status === STATUS_CODES['success']) {       
                                if (result.data.user_data.login_type === LOGIN_TYPE[1]) {
                                    navigate('/mapping-agency-list');
                                } else {
                               navigate('/dashboard');
                                }
                                
                            }else{
                                setLoading(false);
                                setInputField({ ...inputField, email: "", password: "", captcha: '' });
                                navigate('/login');
                            }
                        })
                } else {
                    setLoading(false);
                    toast.error("Invalid credentials.")
                    navigate('/login');

                }

            } catch (error) {
                setLoading(false);
                toast.error("Invalid credentials.")
                navigate('/login');
            }
        }
        // eslint-disable-next-line
    }, [searchParams]);

    const handleClickShowPassword = () => {
        let pwdstatus=(showPassword)?false:true;
        setShowPassword(pwdstatus);
    }
    return (
        <div className="login-form">

            {/* <FullPageLoader show={loading} /> */}

            {showVerify ?

                (<VerifyOtp submitButton={submitButton} setShowVerify={setShowVerify} userId={userId} inputField={inputField} setInputField={setInputField}  otp={otp} />)
                :
                props.isRegister ? 
                    (
                        <form autoComplete="on">
                             <fieldset className="">
                                <div className={"material " + (errField.email ? "error" : "")}    >
                                    <input
                                        type="text"
                                        placeholder=" "
                                        name="name"
                                        value={inputField.name}
                                        className="form-input"
                                        onChange={inputHandler}
                                    />
                                    <i className="ic-person icn-login"></i>
                                    <label data-label="Name" className="form-label"></label>
                                    {errField.name && (
                                        <span className="error-txt">
                                            {errField['name'] || ""}
                                        </span>
                                    )}
                                </div>
                            </fieldset>
                            <fieldset className="">
                                <div className={"material " + (errField.email ? "error" : "")}    >
                                    <input
                                        type="text"
                                        placeholder=" "
                                        name="email"
                                        value={inputField.email}
                                        className="form-input"
                                        onChange={inputHandler}
                                    />
                                    <i className="ic-email1 icn-login"></i>
                                    <label data-label="Email" className="form-label"></label>
                                    {errField.email && (
                                        <span className="error-txt">
                                            {errField['email'] || ""}
                                        </span>
                                    )}
                                </div>
                            </fieldset>

                            <fieldset className="">
                                <div className={"material " + (errField.mobile ? "error" : "")}    >
                                    <input
                                        type="number"
                                        placeholder=" "
                                        name="mobile"
                                        value={inputField.mobile}
                                        className="form-input"
                                        onChange={inputHandler}
                                    />
                                    <i className="ic-mobile icn-login"></i>
                                    <label data-label="Mobile No." className="form-label"></label>
                                    {errField.mobile && (
                                        <span className="error-txt">
                                            {errField.mobile || ""}
                                        </span>
                                    )}
                                </div>
                            </fieldset>

                            {/* <fieldset className=" captcha-filed">
                                <Captcha onKeyPressCaptcha={captchaFiledHandler} errField={errField} inputField={inputField} reloadCaptcha={reloadCaptcha || props.showCaptcha} />
    
                            </fieldset> */}
    
                            <div className="language-selectors">
    
                                <button type="button" className="btn-primary" onClick={submitButton} disabled={loading}>
                                    Register
                                </button>
    
                            </div>
                            <div className="login-link-container">
                                <p className='t-center'>Already have an account - <Link to="/login" >Login</Link></p>
                            </div>
    
                        </form>
                    ) : 
                    (
                        <>
                            <GoogleLoginComponent setUserId={setUserId} setShowVerify={setShowVerify} setGoogleLogin={setGoogleLogin} setInputField={setInputField} />
                            <h3 className='t-center'>OR</h3>
                            <form autoComplete="on">
                                <fieldset className="">
                                    <div className={"material " + (errField.email ? "error" : "")}    >
                                        <input
                                            type="text"
                                            placeholder=" "
                                            name="email"
                                            value={inputField.email}
                                            className="form-input"
                                            onChange={inputHandler}
                                        />
                                        <i className="ic-email1 icn-login"></i>
                                        <label data-label="Email" className="form-label"></label>
                                        {errField.email && (
                                            <span className="error-txt">
                                                {errField['email'] || ""}
                                            </span>
                                        )}
                                    </div>
                                </fieldset>
                                <fieldset className="">
                                    <div className={"material " + (errField.password ? "error" : "")}>
                                        <input
                                            type={(showPassword)?"text":"password"}
                                            placeholder=" "
                                            name="password"
                                            value={inputField.password}
                                            className="form-input password-txt"
                                            onChange={inputHandler}
                                        />
                                        <i className="ic-password icn-login"></i>
                                        <label data-label="Password" className="form-label"></label>
                                        <span className="password-show pwd-show-hide" onClick={handleClickShowPassword}><i className="ic-close_eye" ></i><i className="ic-open_eye"></i></span>
                                        {errField.password && (
                                            <span className="error-txt">
                                                {errField['password'] || ""}
                                            </span>
                                        )}
                                    </div>
                                </fieldset>
                                <fieldset className=" captcha-filed">
                                    <Captcha onKeyPressCaptcha={captchaFiledHandler} errField={errField} inputField={inputField} reloadCaptcha={reloadCaptcha || props.showCaptcha} />
                                    <div className="forgot-password-container">
                                        <Link to="/forgot-password" className="forgot-password-link">
                                            Forgot Password?
                                        </Link>
                                    </div>
                                </fieldset>
        
                                <div className="language-selectors">
        
                                    <button type="button" className="btn-primary w-100" onClick={submitButton} disabled={loading}>
                                        Login
                                    </button>
                
                                </div>
                                <div className="login-link-container">
                                    <Link to="/register" >
                                        <p className='t-center'>Register With Us</p>
                                    </Link>
                                </div>
        
                            </form>
                        </>
                    )
            }
        </div>
    );
}

export default EmailUser;